<template>
  <div class="animated fadeIn mt-3" id="report">
    <h1 class="text-uppercase font-weight-bold">Avances</h1>
  </div>
</template>
<script>
export default {
  name: "Avances"
};
</script>
<style></style>
